import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SystemIconComponentModule } from '../icon/icon.component';

@Component({
  selector: 'app-system-alerts',
  templateUrl: './alerts.component.html',
})
export class AlertsComponent {
  @Input({
    required: true,
  })
  type: 'success' | 'warning' | 'info' | 'danger' = 'success';
  @Input({
    required: true,
  })
  message = '';
  @Input({ required: true }) title = '';
  @Input({ required: true }) icon = '';
  constructor() {}
}

@NgModule({
  declarations: [AlertsComponent],
  exports: [AlertsComponent],
  imports: [TranslateModule, CommonModule, SystemIconComponentModule],
})
export class SystemAlertsModule {}
